import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging } from '~/infrastructure/paging';
import { StatusDto } from '~/models/modules/Asset/status';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class StatusesService extends ApiServiceBase {

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.assets);
  }




  getStatusGrid(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
        .post<any[]>(this._url(`/grid-data`), model, {
            params,
            observe: 'response',
        })
        .pipe(map(augmentPaging));
  }

  // getStatusListing(){
  //   return this.http.get<StatusDto[]>(this._url());
  // }
  getStatusListing(model: any = {}){
    //return this.http.post<ConditionDto[]>(this._url());
    return this.http.post<StatusDto[]>(this._url(`/statusListing`), model);
  }

  getStatusById(id : number){
    return this.http.get<StatusDto>(this._url(`/${id}`));
  }



  createStatus(model : any){
    return this.client.post<StatusDto>(this._url(), model);
  }

  updateStatus(id: number, model : any){
    return this.client.put<any>(this._url(`/${id}`), model);
  }

  deactivateStatus(obj: any) {
    return this.client.put(this._url(`/deactivate`), obj);
  }

  deactivateStatusBatch(obj: any) {
    return this.client.put(this._url(`/batchDeactivate`), obj);
  }

  reactivateStatus(id: number) {
    return this.client.put(this._url(`/reactivate/${id}`), null);
  }
  reactivateStatusBatch(obj: any) {
    return this.client.put(this._url(`/reactivate-batch`), obj);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/Statuses${v}`);
  }
}
